import { Entry } from '../Entry'

export function Entry20240221() {
  return (
    <Entry title="Feb 21 2024 - v3.5.15">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15694/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
